<div *ngIf="isString(headerKey) || isString(messageKey)" class="alert alert-danger" role="group" tabindex="-1">
  <h2 *ngIf="isString(headerKey)">{{ headerKey | translate }}</h2>
  <p *ngIf="isString(messageKey)">{{ messageKey | translate }}</p>
</div>
